<template>
  <div class="new-home-banner bg-info">
    <i class="fa fa-info-circle"/>
    <slot name="message"/>
  </div>
</template>

<script>

export default {
  name: 'HomePageUpdateBanner',
}
</script>

<style scoped lang="less">
.new-home-banner {
  margin: 1rem 0;
  padding: 1rem;
  text-align: center;
  span {
    font-size: 1rem;
    line-height: 1.22rem;
    font-weight: bold;
  }
}
</style>
